/**
* DevExpress Analytics (core\widgets\bordereditor\_binding.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var $ = require("jquery");
var _bordereditor_1 = require("./_bordereditor");
var templateUtils_1 = require("../../../property-grid/widgets/templateUtils");
ko.bindingHandlers['dxBorderEditor'] = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        $(element).children().remove();
        var templateHtml = templateUtils_1.getTemplate('dxrd-bordereditor'), $element = $(element).append(templateHtml);
        ko.applyBindings({ value: new _bordereditor_1.BordersModel(valueAccessor(), viewModel.disabled) }, $element.children()[0]);
        return { controlsDescendantBindings: true };
    }
};
